type R3FWindow = Window & { r3f?: { invalidate?: () => void } }

let scheduled = false

/** Un invalidate por frame tras cargas async (frameloop demand). */
export function scheduleInvalidateR3F() {
  if (typeof window === 'undefined' || scheduled) return
  scheduled = true
  requestAnimationFrame(() => {
    scheduled = false
    const r3f = (window as R3FWindow).r3f
    r3f?.invalidate?.()
  })
}
